export async function downloadDocument(fileName, blob) {
  const url = window.URL.createObjectURL(await blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}
